import * as Yup from 'yup'

export const pocketsSchema = Yup.object().shape({
  pockets: Yup.array().required('Please select atleast one account'),
})
